export default {
  currentStep: 0,
  countries: {
    list: [
      { name: 'United Kingdom', value: 'uk' },
      { name: 'France', value: 'fr' },
      { name: 'Ireland', value: 'ire' },
      { name: 'Singapore', value: 'sg' },
      { name: 'Other', value: 'other' },
    ],
    selected: 'uk',
    otherName: '',
  },
  raising: 200000,

  nextRound: 1000000,
  discount: 20,
  cap: 2500000,
  floor: 1000000,

  low: 1500000,

  valuation: 6000000,
};
